import React, { useState, useEffect, Fragment } from 'react'
import { AppGridLayoutDesigerContext } from './AppGridLayoutDesigerContext'
import { AppGridLayoutHeardDesiger } from './AppGridLayoutHeardDesiger'
import './index.less'
import { AppGridLayoutBodyDesiger } from './AppGridLayoutBodyDesiger'
import api from 'api'
import { MetadataGrid, MetadataEntity } from '../../../../api/index'
import { GetQueryString } from 'utils'

export default function AppGridLayoutDesiger() {
	const [view, setView] = useState('列表设计')
	const [currSelectd, setCurrSelected] = useState({ type: 'projectFilter' })
	const [metadataGird, setMetadataGrid] = useState({} as MetadataGrid)
	const [metadataEntity, setMetadataEntity] = useState({} as MetadataEntity)
	const [tableViewId, setTableViewId] = useState(0)
	const loadMetaData = async () => {
		let id = GetQueryString('id')
		if (!id || id === null) {
			id = '0'
		}
		let res = await api.modeling.appgrid.getOneDesiger({
			id: Number(id),
			application: GetQueryString('application'),
		})
		setMetadataGrid(res)
		loadFieldList(res)
	}
	const loadFieldList = async (res: MetadataGrid) => {
		let id = res.appGridLayout.entityId
		if (id) {
			let entity = await api.modeling.entity.getOne({ id, application: '00' })
			setMetadataEntity(entity)
		}
	}
	useEffect(() => {
		loadMetaData()
	}, [])
	const chgView = (v: string) => {
		setView(v)
	}
	return (
		<Fragment>
			{JSON.stringify(metadataGird) === '{}' ? (
				''
			) : (
				<AppGridLayoutDesigerContext.Provider
					value={{
						view,
						chgView,
						currSelectd,
						setCurrSelected,
						metadataGird,
						setMetadataGrid,
						loadFieldList,
						metadataEntity,
						tableViewId,
						setTableViewId,
					}}
				>
					{console.log('metadataGird', metadataGird, currSelectd)}
					<div className="app-grid-layout-desiger">
						<AppGridLayoutHeardDesiger />
						<AppGridLayoutBodyDesiger />
					</div>
				</AppGridLayoutDesigerContext.Provider>
			)}
		</Fragment>
	)
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/AppGridLayoutDesiger/AppGridLayoutDesiger.tsx